// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { getDateToCall } from '../lib/generateTimes'
import moment from '../Moment'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  userDataContactPhone: ['phoneNumber'],
  userDataDate: ['callbackDate'],
  userDataTime: ['callbackTime'],
  userDataTimes: ['callbackTimes'],
  userDataTimesFrom: ['callbackTimesFrom'],
  userDataTimesTo: ['callbackTimesTo'],
  userDataContact: ['key', 'value'],
  userDataInit: ['specification'],
  userDataSetValue: ['key', 'value'],
  userDataSetData: ['data'],
  userDataGenTimes: ['date'],
  toggleModalOpened: ['modalOpened'],
  setOperatingHoursFromContent: ['operatingHours'],
})

export const UserDataTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  // eslint-disable-line
  data: {
    contact: {
      phoneNumber: '',
    },
    callbackDate: '',
    callbackTime: { value: '', label: '' },
    callbackTimes: [],
    callbackTimesTo: [],
    callbackTimesFrom: [],
    modalOpened: false,
    requestId: '',
    quoteId: '',
    productName: '',
    firstName: '',
    lastName: '',
    callTopic: 'general',
    contractId: '',
  },
  closed: [],
  operatingHoursFromContent: {},
})

/* ------------- Reducers ------------- */
export const userDataTimeR = (state, { callbackTime }) => state.setIn(['data', 'callbackTime'], callbackTime)

export const userDataSetTimes = (state, { callbackTimes }) => state.setIn(['data', 'callbackTimes'], callbackTimes)

export const userDataSetTimesFrom = (state, { callbackTimesFrom }) =>
  state.setIn(['data', 'callbackTimesFrom'], callbackTimesFrom)

export const userDataSetTimesTo = (state, { callbackTimesTo }) =>
  state.setIn(['data', 'callbackTimesTo'], callbackTimesTo)

export const userDataSetDate = (state, { callbackDate }) => state.setIn(['data', 'callbackDate'], callbackDate)

export const userDataSetValueR = (state, { key, value }) => state.setIn(['data', key], value)

export const userDataContactPhone = (state, key, value) => state.setIn(['data', 'contact', key], value)

export const userDataGenTimesR = (state, { date }) => {
  const [dateToCall, enabledTimesArr, timeFromArray, timeToArray] = getDateToCall(
    moment(date),
    state.closed,
    state.operatingHoursFromContent,
  )
  return state
    .setIn(['data', 'callbackTime'], enabledTimesArr[0])
    .setIn(['data', 'callbackDate'], dateToCall.format('YYYY-MM-DD'))
    .setIn(['data', 'callbackTimesFrom'], timeFromArray)
    .setIn(['data', 'callbackTimesTo'], timeToArray)
    .setIn(['data', 'callbackTimes'], enabledTimesArr)
}

export const userDataInitR = (state, { specification }) => {
  const data = { ...state.data }
  specification.fields.map((field) => {
    if (field.domain._type === 'object') {
      data[field.name] = data[field.name] || {}
    }
  })
  return state.merge({ data })
}

export const userDataSetDataR = (state, { data }) => state.merge({ data: { ...state.data, ...data } })

export const toggleModalOpenedR = (state, { modalOpened }) => {
  if (typeof modalOpened === 'boolean') {
    return state.setIn(['data', 'modalOpened'], modalOpened)
  }
  return state.setIn(['data', 'modalOpened'], !state.getIn(['data', 'modalOpened'], false))
}

const setOperatingHoursFromContentR = (state, { operatingHours }) => {
  if (typeof operatingHours === 'object' && Object.keys(operatingHours).length > 0) {
    const closed = []
    const operatingHoursFromContent = {}
    Object.keys(operatingHours).forEach((date) => {
      const dateMoment = moment(date, ['DD.MM.YYYY', 'D.MM.YYYY', 'DD.M.YYYY', 'D.M.YYYY'], true)
      if (dateMoment.isValid()) {
        if (operatingHours[date] === 'closed') {
          closed.push(dateMoment.format('YYYY-MM-DD'))
        } else if (typeof operatingHours[date] === 'string' && operatingHours[date].includes('-')) {
          const timesArray = operatingHours[date].split('-')
          const timeFormats = ['HH:mm', 'H:m', 'H:mm', 'HH:m']
          if (timesArray.length === 2) {
            const timeFrom = moment(timesArray[0], timeFormats, true)
            const timeTo = moment(timesArray[1], timeFormats, true)
            if (timeFrom.isValid() && timeTo.isValid()) {
              operatingHoursFromContent[dateMoment.format('YYYY-MM-DD')] = {
                timeFrom: timeFrom.format('HH:mm'),
                timeTo: timeTo.format('HH:mm'),
              }
            }
          }
        }
      }
    })
    const newState = state.set('operatingHoursFromContent', operatingHoursFromContent).set('closed', closed)
    return userDataGenTimesR(newState, {})
  }
  return state
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.USER_DATA_DATE]: userDataSetDate,
  [Types.USER_DATA_TIME]: userDataTimeR,
  [Types.USER_DATA_TIMES]: userDataSetTimes,
  [Types.USER_DATA_TIMES_FROM]: userDataSetTimesFrom,
  [Types.USER_DATA_TIMES_TO]: userDataSetTimesTo,
  [Types.USER_DATA_CONTACT_PHONE]: (state, { phoneNumber }) => userDataContactPhone(state, 'phoneNumber', phoneNumber),
  [Types.USER_DATA_SET_VALUE]: userDataSetValueR,
  [Types.USER_DATA_INIT]: userDataInitR,
  [Types.USER_DATA_SET_DATA]: userDataSetDataR,
  [Types.USER_DATA_GEN_TIMES]: userDataGenTimesR,
  [Types.TOGGLE_MODAL_OPENED]: toggleModalOpenedR,
  [Types.SET_OPERATING_HOURS_FROM_CONTENT]: setOperatingHoursFromContentR,
})
